import React from 'react';
import { Box, Text, HStack, VStack, Image, Flex, Divider, Button, Icon } from '@chakra-ui/react';
import { FaShippingFast } from 'react-icons/fa';
import { BadgesStatusVenda, DatasDespacho } from './StatusVendaMeta';

const CardVendaOutroStatus = ({ venda, onAntecipar, anteciparLoading = false }) => {
    const podeAntecipar = !!venda.pode_antecipar && typeof onAntecipar === 'function';

    return (
        <Box borderWidth="2px" borderColor="blue.200" borderRadius="xl" bg="blue.50" p={4} boxShadow="sm">
            <Flex justify="space-between" align="flex-start" mb={2} wrap="wrap" gap={2}>
                <VStack align="flex-start" spacing={1.5}>
                    <BadgesStatusVenda origem={venda.origem} status={venda.status} statusTaga={venda.status_taga} />
                    <DatasDespacho dataVenda={venda.data_venda} prazoEnvio={venda.prazo_envio} />
                </VStack>
                <HStack fontSize="xs" color="gray.600" spacing={3} flexWrap="wrap">
                    <Text>Venda #{venda.venda_id}</Text>
                    {venda.id_origem && <Text>Orig: {venda.id_origem}</Text>}
                    {venda.pack_id && <Text>Pack: {venda.pack_id}</Text>}
                    <Text noOfLines={1}>{venda.cliente}</Text>
                </HStack>
            </Flex>

            <Divider borderColor="blue.100" mb={3} />

            <VStack spacing={2} align="stretch">
                {(venda.itens || []).map((item, idx) => (
                    <Box key={idx} bg="white" borderRadius="lg" p={3} borderWidth="1px" borderColor="blue.100">
                        <HStack spacing={3} align="flex-start">
                            {item.imagem && (
                                <Image src={item.imagem} alt={item.nome} boxSize="50px"
                                    objectFit="contain" borderRadius="md" flexShrink={0} />
                            )}
                            <VStack align="stretch" spacing={1} flex={1} minW={0}>
                                <Text fontSize="sm" fontWeight="bold" color="gray.800" bg="gray.100"
                                    px={2.5} py={1.5} borderRadius="md" lineHeight="tight"
                                    whiteSpace="normal" wordBreak="break-word" w="100%">
                                    {item.nome}
                                </Text>
                                <Flex wrap="wrap" columnGap={2} rowGap={1}>
                                    {item.produto_id && (
                                        <Text fontSize="11px" color="gray.500" whiteSpace="nowrap">
                                            <Text as="span" fontWeight="bold" color="gray.600">SKU:</Text> {item.produto_id}
                                        </Text>
                                    )}
                                    {item.global_code && (
                                        <Text fontSize="11px" color="gray.500" whiteSpace="nowrap">
                                            <Text as="span" fontWeight="bold" color="gray.600">Global:</Text> {item.global_code}
                                        </Text>
                                    )}
                                    {item.marca && (
                                        <Text fontSize="11px" color="gray.500" whiteSpace="nowrap">
                                            <Text as="span" fontWeight="bold" color="gray.600">Marca:</Text> {item.marca}
                                        </Text>
                                    )}
                                    {item.codigo_barra && (
                                        <Text fontSize="11px" color="gray.500" whiteSpace="nowrap">
                                            <Text as="span" fontWeight="bold" color="gray.600">Cód. Barra:</Text> {item.codigo_barra}
                                        </Text>
                                    )}
                                    <Text fontSize="11px" color="gray.500" whiteSpace="nowrap">
                                        <Text as="span" fontWeight="bold" color="gray.600">Qtd:</Text> {item.quantidade}
                                    </Text>
                                </Flex>
                            </VStack>
                        </HStack>
                    </Box>
                ))}
            </VStack>

            {podeAntecipar && (
                <>
                    <Divider borderColor="blue.100" mt={3} mb={3} />
                    <Flex justify="space-between" align="center" gap={3} wrap="wrap">
                        <Text fontSize="11px" color="gray.600" flex="1" minW="200px">
                            Peça já recebida na TAGA? Antecipe o despacho para hoje
                            {venda.antecipa_no_canal ? ' e avise o Mercado Livre que o produto já está disponível.' : '.'}
                        </Text>
                        <Button
                            size="sm"
                            colorScheme="orange"
                            leftIcon={<Icon as={FaShippingFast} />}
                            onClick={() => onAntecipar(venda)}
                            isLoading={anteciparLoading}
                            loadingText="Antecipando"
                            flexShrink={0}
                        >
                            Antecipar despacho
                        </Button>
                    </Flex>
                </>
            )}
        </Box>
    );
};

export default CardVendaOutroStatus;
